import React, { useEffect, useState } from "react";

import {
  Modal,
  Form,
  Input,
  Button,
  Row,
  Col,
  Select,
  Radio,
  DatePicker,
} from "antd";

import dayjs from "dayjs";
import {
  calculateTicketPrice,
  getCurrentPricingConfig,
  loadPricingConfig,
} from "../pricing/pricingService";

const countries = [
  "Afganistán",
  "Albania",
  "Alemania",
  "Andorra",
  "Angola",
  "Antigua y Barbuda",
  "Arabia Saudita",
  "Argelia",
  "Argentina",
  "Armenia",
  "Australia",
  "Austria",
  "Azerbaiyán",
  "Bahamas",
  "Bangladés",
  "Barbados",
  "Baréin",
  "Bélgica",
  "Belice",
  "Benín",
  "Bielorrusia",
  "Bolivia",
  "Bosnia y Herzegovina",
  "Botsuana",
  "Brasil",
  "Brunéi",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Bután",
  "Cabo Verde",
  "Camboya",
  "Camerún",
  "Canadá",
  "Catar",
  "Chad",
  "Chile",
  "China",
  "Chipre",
  "Colombia",
  "Comoras",
  "Corea del Norte",
  "Corea del Sur",
  "Costa de Marfil",
  "Costa Rica",
  "Croacia",
  "Cuba",
  "Dinamarca",
  "Dominica",
  "Ecuador",
  "Egipto",
  "El Salvador",
  "Emiratos Árabes Unidos",
  "Eritrea",
  "Eslovaquia",
  "Eslovenia",
  "España",
  "Estados Unidos",
  "Estonia",
  "Esuatini",
  "Etiopía",
  "Filipinas",
  "Finlandia",
  "Fiyi",
  "Francia",
  "Gabón",
  "Gambia",
  "Georgia",
  "Ghana",
  "Granada",
  "Grecia",
  "Guatemala",
  "Guinea",
  "Guinea-Bisáu",
  "Guinea Ecuatorial",
  "Guyana",
  "Haití",
  "Honduras",
  "Hungría",
  "India",
  "Indonesia",
  "Irak",
  "Irán",
  "Irlanda",
  "Islandia",
  "Islas Marshall",
  "Islas Salomón",
  "Israel",
  "Italia",
  "Jamaica",
  "Japón",
  "Jordania",
  "Kazajistán",
  "Kenia",
  "Kirguistán",
  "Kiribati",
  "Kuwait",
  "Laos",
  "Lesoto",
  "Letonia",
  "Líbano",
  "Liberia",
  "Libia",
  "Liechtenstein",
  "Lituania",
  "Luxemburgo",
  "Madagascar",
  "Malasia",
  "Malaui",
  "Maldivas",
  "Malí",
  "Malta",
  "Marruecos",
  "Mauricio",
  "Mauritania",
  "México",
  "Micronesia",
  "Moldavia",
  "Mónaco",
  "Mongolia",
  "Montenegro",
  "Mozambique",
  "Namibia",
  "Nauru",
  "Nepal",
  "Nicaragua",
  "Níger",
  "Nigeria",
  "Noruega",
  "Nueva Zelanda",
  "Omán",
  "Países Bajos",
  "Pakistán",
  "Palaos",
  "Panamá",
  "Papúa Nueva Guinea",
  "Paraguay",
  "Perú",
  "Polonia",
  "Portugal",
  "Reino Unido",
  "República Centroafricana",
  "República Checa",
  "República del Congo",
  "República Democrática del Congo",
  "República Dominicana",
  "Ruanda",
  "Rumanía",
  "Rusia",
  "Samoa",
  "San Cristóbal y Nieves",
  "San Marino",
  "San Vicente y las Granadinas",
  "Santa Lucía",
  "Santo Tomé y Príncipe",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leona",
  "Singapur",
  "Siria",
  "Somalia",
  "Sri Lanka",
  "Sudáfrica",
  "Sudán",
  "Sudán del Sur",
  "Suecia",
  "Suiza",
  "Surinam",
  "Tailandia",
  "Tanzania",
  "Tayikistán",
  "Timor Oriental",
  "Togo",
  "Tonga",
  "Trinidad y Tobago",
  "Túnez",
  "Turkmenistán",
  "Turquía",
  "Tuvalu",
  "Ucrania",
  "Uganda",
  "Uruguay",
  "Uzbekistán",
  "Vanuatu",
  "Vaticano",
  "Venezuela",
  "Vietnam",
  "Yemen",
  "Yibuti",
  "Zambia",
  "Zimbabue",
];

const TicketForm = ({
  onSave,
  handleCreateTicket,
  ticketData = null, // Pasar el ticket a editar o null si es nuevo
}) => {
  const [total, setTotal] = useState(0); // Inicializa el estado con 0
  const [isEmpresaLocal, setEmpresaLocal] = useState(false);
  const [availableEntryTypes, setAvailableEntryTypes] = useState([
    { value: "general", label: "Individual General" },
    {
      value: "pensionista",
      label: "Individual pensionista, desempleado/a, estudiante y docente",
    },
    { value: "grupo", label: "Grupo organizado de 20 o más personas" },
    { value: "centroDocente", label: "Centro Docente" },
  ]);

  const [form] = Form.useForm();
  const [pricingConfig, setPricingConfig] = useState(getCurrentPricingConfig());
  const [availableVisits, setAvailableVisits] = useState([
    { value: "CAB", label: "CASTILLO Y BARBACANA" },
    { value: "ANH", label: "ANTIGUO HOSPITAL NTRA. SRA. DE LOS ÁNGELES" },
    {
      value: "GIA1",
      label:
        "VISITA GUIADA IGLESIA NTRA SRA. DE LA GRANADA, ANTIGUO HOSPITAL DE LOS ÁNGELES Y MIRADOR PUERTA DEL BUEY.",
    },
    {
      value: "GIA2",
      label:
        "CASTILLO DE LOS GUZMANES, BARBACANA, PUERTA DEL SOCORRO, IGLESIA DE SAN MARTÍN, IGLESIA NTRA SRA DE LA GRANADA, ANTIGUO HOSPITAL NTRA SRA DE LOS ÁNGELES, MIRADOR PUERTA DEL BUEY Y ZONA ARQUEOLÓGICA PUERTA DE SEVILLA.",
    },
  ]);

  useEffect(() => {
    let isMounted = true;

    loadPricingConfig().then((config) => {
      if (!isMounted) {
        return;
      }

      setPricingConfig(config);
      const currentValues = form.getFieldsValue();
      const calculatedTotal = calculateTicketPrice(
        currentValues,
        availableVisits,
        config,
      );
      setTotal(calculatedTotal);
    });

    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form]);

  useEffect(() => {
    if (ticketData) {
      console.log("HAY TCIKET DATA");
      ticketData.fechaYHora = dayjs(ticketData.fechaYHora);
      form.setFieldsValue(ticketData); // Cargar los valores existentes
      console.log("SE FORMATEAN DATOS DEFAULT DEL FORM");
      // Forzar la actualización del total con los valores actuales del formulario
      const currentValues = form.getFieldsValue(); // Obtiene los valores actuales del formulario

      console.log("VALORES ACTUALES DEL FORMULARIO", currentValues);
      const calculatedTotal = calculateTicketPrice(
        currentValues,
        availableVisits,
        pricingConfig,
      ); // Calcula el total con los valores actuales

      console.log("TOTAL CALCULADO", calculatedTotal);

      setTotal(calculatedTotal); // Actualiza el total en el estado
    } else {
      form.resetFields(); // Limpiar el formulario para un nuevo ticket
      setTotal(0); // Resetear total
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ticketData]);

  // Manejo del formulario
  const handleFinish = (values) => {
    onSave(values); // Guardar los datos

    values.precio = calculateTicketPrice(
      values,
      availableVisits,
      pricingConfig,
    );

    const visitLabel =
      availableVisits.find((visit) => visit.value === values.visita)?.label ||
      values.visita;
    values.visita = visitLabel; // Cambiar el valor de visita por la etiqueta
    handleCreateTicket(values); // Crear el ticket

    form.resetFields(); // Limpia el formulario
  };

  const handleCancel = () => {
    form.resetFields(); // Limpia el formulario
  };

  const handleFormChange = (changedValues, allValues) => {
    // Solo actualizar visitas y tipos de entrada cuando cambia empresaLocal
    if ("empresaLocal" in changedValues) {
      const isLocalCompany = allValues.empresaLocal === true;

      setEmpresaLocal(isLocalCompany);

      const nextEntryTypes = isLocalCompany
        ? [
            {
              value: "grupo",
              label: "Grupo organizado de 20 o más personas",
            },
          ]
        : [
            { value: "general", label: "Individual General" },
            {
              value: "pensionista",
              label:
                "Individual pensionista, desempleado/a, estudiante y docente",
            },
            {
              value: "grupo",
              label: "Grupo organizado de 20 o más personas",
            },
            { value: "centroDocente", label: "Centro Docente" },
          ];

      setAvailableEntryTypes(nextEntryTypes);

      const nextAvailableVisits = isLocalCompany
        ? [
            {
              value: "GIA1",
              label:
                "VISITA GUIADA IGLESIA NTRA SRA. DE LA GRANADA, ANTIGUO HOSPITAL DE LOS ÁNGELES Y MIRADOR PUERTA DEL BUEY.",
            },
            {
              value: "GIA2",
              label:
                "CASTILLO DE LOS GUZMANES, BARBACANA, PUERTA DEL SOCORRO, IGLESIA DE SAN MARTÍN, IGLESIA NTRA SRA DE LA GRANADA, ANTIGUO HOSPITAL NTRA SRA DE LOS ÁNGELES, MIRADOR PUERTA DEL BUEY Y ZONA ARQUEOLÓGICA PUERTA DE SEVILLA.",
            },
          ]
        : [
            { value: "CAB", label: "CASTILLO Y BARBACANA" },
            {
              value: "ANH",
              label: "ANTIGUO HOSPITAL NTRA. SRA. DE LOS ÁNGELES",
            },
            {
              value: "GIA1",
              label:
                "VISITA GUIADA IGLESIA NTRA SRA. DE LA GRANADA, ANTIGUO HOSPITAL DE LOS ÁNGELES Y MIRADOR PUERTA DEL BUEY.",
            },
            {
              value: "GIA2",
              label:
                "CASTILLO DE LOS GUZMANES, BARBACANA, PUERTA DEL SOCORRO, IGLESIA DE SAN MARTÍN, IGLESIA NTRA SRA DE LA GRANADA, ANTIGUO HOSPITAL NTRA SRA DE LOS ÁNGELES, MIRADOR PUERTA DEL BUEY Y ZONA ARQUEOLÓGICA PUERTA DE SEVILLA.",
            },
          ];

      setAvailableVisits(nextAvailableVisits);

      if (isLocalCompany) {
        form.setFieldsValue({ tipoEntrada: "grupo" });
      }

      const calculatedTotal = calculateTicketPrice(
        allValues,
        nextAvailableVisits,
        pricingConfig,
      );
      setTotal(calculatedTotal);
    } else {
      // Para cualquier otro cambio, solo recalcular el total
      const calculatedTotal = calculateTicketPrice(
        allValues,
        availableVisits,
        pricingConfig,
      );
      setTotal(calculatedTotal);
    }
  };

  return (
    <Form
      form={form}
      layout="vertical"
      size="small"
      initialValues={{
        empresaLocal: false,
        nombreTecnico: "Técnico",
        visita: "CAB",
        tipoEntrada: "general",
        guia: "propio",
        enviarEmail: false,
        grupoSize: 0,
        paisOrigen: "España",
        fechaYHora: dayjs(),
      }}
      onFinish={handleFinish}
      style={{ gap: "8px" }}
      onValuesChange={handleFormChange}
    >
      {/* Nombre Técnico */}
      <Form.Item name="id" hidden>
        <Input />
      </Form.Item>

      <Row gutter={[16, 8]}>
        {/* <Col span={24}>
          <Form.Item
            name="nombreTecnico"
            label="Nombre Técnico Ayuntamiento"
            rules={[{ required: true, message: "Este campo es obligatorio" }]}
            style={{ marginBottom: "8px" }}
          >
            <Input
              placeholder="Escribe el nombre técnico"
              style={{ width: "100%", height: "36px" }}
            />
          </Form.Item>
        </Col> */}
      </Row>

      {/* Información Personal */}
      <Row gutter={[16, 8]}>
        <Col span={24}>
          <Form.Item
            name="informacionPersonal"
            label="Nombre y Apellidos"
            rules={[{ required: true, message: "Este campo es obligatorio" }]}
            style={{ marginBottom: "8px" }}
          >
            <Input
              placeholder="Escribe tu nombre completo"
              style={{ width: "100%", height: "36px" }}
            />
          </Form.Item>
        </Col>
      </Row>

      {/* Email y País de Origen */}
      <Row gutter={[16, 8]}>
        <Col span={24}>
          <Form.Item
            name="email"
            label="Email para enviar ticket"
            rules={[
              {
                required: form.getFieldValue("enviarEmail") === true,
                message: "Este campo es obligatorio",
              },
              { type: "email", message: "Introduce un email válido" },
            ]}
            style={{ marginBottom: "8px" }}
          >
            <Input
              placeholder="ejemplo@correo.com"
              style={{ width: "100%", height: "36px" }}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name="paisOrigen"
            label="País de Origen"
            rules={[{ required: true, message: "Este campo es obligatorio" }]}
            style={{ marginBottom: "8px" }}
          >
            <Select
              placeholder="Selecciona un país"
              style={{ width: "100%", height: "36px" }}
              showSearch
              filterOption={(input, option) =>
                option.children.toLowerCase().includes(input.toLowerCase())
              }
            >
              {countries.map((country) => (
                <Select.Option key={country} value={country}>
                  {country}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name="provincia"
            label="Provincia"
            rules={[{ required: true, message: "Este campo es obligatorio" }]}
            style={{ marginBottom: "8px" }}
          >
            <Input style={{ width: "100%", height: "36px" }} />
          </Form.Item>
        </Col>
      </Row>

      {/* Tipo de Entrada y Empresa Local */}
      <Row gutter={[16, 8]}>
        <Col span={12}>
          <Form.Item
            name="tipoEntrada"
            label="Tipo de Entrada"
            rules={[{ required: true, message: "Este campo es obligatorio" }]}
            style={{ marginBottom: "8px" }}
          >
            <Select
              placeholder="Selecciona un tipo de entrada"
              style={{ width: "100%", height: "36px" }}
              disabled={isEmpresaLocal} // Deshabilitar si es Empresa Local
            >
              {availableEntryTypes.map((entryType) => (
                <Select.Option key={entryType.value} value={entryType.value}>
                  {entryType.label}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name="empresaLocal"
            label="Empresa Local"
            rules={[{ required: true, message: "Este campo es obligatorio" }]}
            style={{ marginBottom: "8px" }}
          >
            <Radio.Group>
              <Radio value={true}>Sí</Radio>
              <Radio value={false}>No</Radio>
            </Radio.Group>
          </Form.Item>
        </Col>
      </Row>

      {/* Visita */}
      <Row gutter={[16, 8]}>
        <Col span={24}>
          <Form.Item
            name="visita"
            label="Visita"
            rules={[{ required: true, message: "Este campo es obligatorio" }]}
            style={{ marginBottom: "8px" }}
          >
            <Select
              placeholder="Selecciona una visita"
              style={{ width: "100%", height: "36px" }}
            >
              {availableVisits.map((visit) => (
                <Select.Option key={visit.value} value={visit.value}>
                  {visit.label}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>

      {/* Fecha y Hora */}
      <Row gutter={[16, 8]}>
        <Col span={18}>
          <Form.Item
            name="fechaYHora"
            label="Fecha y Hora del Evento"
            rules={[
              {
                required: true,
                message: "Por favor selecciona una fecha y hora",
              },
            ]}
            style={{ marginBottom: "8px" }}
          >
            <DatePicker
              showTime
              format="YYYY-MM-DD HH:mm"
              style={{ width: "100%", height: "36px" }}
              placeholder="Selecciona fecha y hora"
            />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            name="grupoSize"
            label="Personas"
            rules={[{ required: true, message: "Este campo es obligatorio" }]}
            style={{ marginBottom: "8px" }}
          >
            <Input
              type="number"
              min={1}
              placeholder="Introduce el tamaño del grupo"
              style={{ width: "100%", height: "36px" }}
            />
          </Form.Item>
        </Col>
      </Row>

      {/* Guía y Tamaño del Grupo */}
      <Row gutter={[16, 8]}>
        {isEmpresaLocal && (
          <Col span={24}>
            <Form.Item
              name="guia"
              label="Guía"
              rules={[
                {
                  required: isEmpresaLocal,
                  message: "Este campo es obligatorio para empresa local",
                },
              ]}
              style={{ marginBottom: "8px" }}
            >
              <Radio.Group>
                <Radio value="propio">Propio</Radio>
                <Radio value="municipal">Municipal</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
        )}
      </Row>

      {/* Enviar por Email */}
      <Row gutter={[16, 8]}>
        <Col span={12}>
          <Form.Item
            name="enviarEmail"
            label="Enviar ticket por email"
            rules={[{ required: true, message: "Este campo es obligatorio" }]}
            style={{ marginBottom: "8px" }}
          >
            <Radio.Group>
              <Radio value={true}>Sí</Radio>
              <Radio value={false}>No</Radio>
            </Radio.Group>
          </Form.Item>
        </Col>
      </Row>

      {/* Total */}
      <Row gutter={[16, 8]}>
        <Col
          span={24}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: "20px",
          }}
        >
          <h1>{`Total: ${total}€`}</h1>
        </Col>
      </Row>

      {/* Botones */}
      <Row justify="center">
        <Col>
          <Button
            type="primary"
            htmlType="submit"
            size="large"
            style={{ marginRight: "10px" }}
          >
            {ticketData ? "Guardar Cambios" : "Crear Ticket"}
          </Button>
          <Button type="default" size="large" onClick={handleCancel}>
            Cancelar
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default TicketForm;
